<template>
  <div class="flex gap-2">
    <vs-input type="text" class="w-full" v-model="code" :disabled="isDisable" />
    <vs-button
      color="primary"
      type="filled"
      icon="search"
      @click="findByCode(code, null)"
      :disabled="isDisable"
      >Search</vs-button
    >
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/repositoryFactory";

const MasterRepository = RepositoryFactory.get("master");

export default {
  props: {
    isDisable: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    isFullReturn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      code: null,
      data: null,
    };
  },
  methods: {
    async setCode(code) {
      this.code = code;
      if (code == null) {
        this.data = null;
        this.$emit("data", this.data);
      }
    },
    getCode(){
      console.log("this.code", this.code);
      return this.code;
    },
    async findByCode(code, full_return) {
      if (code == "" || code == null) {
        return;
      }

      this.$vs.loading();
      try {
        const param = {
          show_all_hu: true,
          is_full_return: (full_return == null || full_return == undefined) ? this.isFullReturn : full_return,
          is_mobile: false,
        }
        const resp = await MasterRepository.getInvoiceByCode(code, { params: param });
        console.log("resp 60", param, resp)
        if (resp.code == 200) {
          if(resp.data.sales_order.length == 0){
            /*
            this.$vs.notify({
              title: "Error",
              text: "Error while fetching customer invoice: Invoice Sales Order not Found !",
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
            */
            this.$vs.dialog({
              // buttonCancel: "disabled",
              type: "alert",
              color: "danger",
              title: `Warning`,
              text: "Invoice Sales Order not found. Keep proceed data?",
              acceptText: "Ok",
              closedOnBackdrop: false,
              closed: true,
              accept: () => {
                this.data = resp.data;
                this.$emit("data", this.data);
              } 
            });
          } else {
            this.data = resp.data;
            this.$emit("data", this.data);
          }
        } else {
          console.log("resp 65", resp)
          if(resp.data != null){
            resp.message += "<br> SR Code : <br>";
            resp.data.forEach(code => {
              resp.message += code + "<br>";
            });
          }

          this.$vs.notify({
            title: "Error",
            text: "Error while fetching customer invoice: " + resp.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            time:4000,
            click:()=>{
              // Secondary function
              const msg = resp.message.split("<br>");
              console.log(msg);
              if (msg[3] == " atas invoice ini.") {
                this.copyToClipboard( msg[2] );
              } else if (msg[ msg.length-1 ] == " atas invoice ini."){
                let arrMsg = [];
                for (let i = 2; i < msg.length-1; i++) {
                  arrMsg.push(msg[i])
                }
                console.log("arrMsg", arrMsg)
                this.copyToClipboard( arrMsg );
              }
            },
          });
        }
      } catch (error) {
        console.log("error 75", error)
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching customer invoice: " + error.message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      }
      this.$vs.loading.close();
    },
    async setDisabled(disabled) {
      this.isDisable = disabled;
    },
    async copyToClipboard(toCopy) {
      try {
        // If it's an array, join all elements into a single string with newlines
        const text = Array.isArray(toCopy) ? toCopy.join("\n") : String(toCopy);
        console.log("toCopy, text", toCopy, text);
        await navigator.clipboard.writeText(text);
        this.$vs.notify({
          title: "Success",
          text: "SR Code Copied to clipboard!",
          color: "success",
          iconPack: "feather",
          icon: "icon-check-circle",
        });
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: "Error",
          text: "Failed to copy to clipboard",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },
  },
};
</script>
